import { render } from "./aio-login-hcaptcha-card.vue?vue&type=template&id=33535524&scoped=true"
import script from "./aio-login-hcaptcha-card.vue?vue&type=script&lang=js"
export * from "./aio-login-hcaptcha-card.vue?vue&type=script&lang=js"

import "./aio-login-hcaptcha-card.vue?vue&type=style&index=0&id=33535524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33535524"]])

export default __exports__